export function setStorageCurrentSelectedHospitalId(hospitalId) {
    if (!hospitalId) {
        return
    }

    localStorage.setItem('currentHospitalId', hospitalId)
}

export function getStorageCurrentSelectedHospitalId() {
    if (!localStorage.getItem('currentHospitalId')) {
        return null
    }

    return localStorage.getItem('currentHospitalId')
        ? JSON.parse(localStorage.getItem('currentHospitalId'))
        : null
}
